export default __webpack_public_path__ + "static/media/Pause.6d72bb70.svg";